
import { useEffect, useState } from 'react';
import { apiDomain, warName } from '../../..';
import { getLabel } from '../../../InitData';
import Loader from '../../../common/Loader';
import { useFetchCheckbetTicket } from '../../fetchCheckbetTicket';
import { getCheckbetUrl, getConfiguration, getQueryStringVariable, isUKCombinationMaskEnabled, restoreTicketDataWithUkCombinations } from '../../utils';
import SocialShareButtons from '../SocialShareButtons';
import MultipleBetsTicket from './MultipleBetsTicket';
import SingleBetTicket from './SingleBetTicket';
import SystemBetsTicket from './SystemBetsTicket';

function CheckBetLayout1(props) {
	import('../MyBets.css')
    const [data, setData] = useState(null);
    const [showLoader, setShowLoader] = useState(true);
    const conf = getConfiguration();
    const logoURL = apiDomain + `/${warName}/content/images/customer-logo/${conf.logo}`;
    const ticketId =  getQueryStringVariable('ticketId') || getQueryStringVariable('ticket') || props.ticketId;
    const ticketUrl = getCheckbetUrl(ticketId);
    
    var isLive = false;
    if(data && data.live){
        isLive = true;
    }
    const [state] = useFetchCheckbetTicket(ticketId, true, isLive, isLive, false);

    useEffect(() => {
        if (!state.isLoading && !state.isError) {
            if(state.data && isUKCombinationMaskEnabled() && state.data.type === 'systembets'){
            	restoreTicketDataWithUkCombinations(state.data, true);
            }
            setData(state.data);
            setShowLoader(false);
            if(props.onDataFetchComplete) {
                props.onDataFetchComplete(state.data);
            }
        }
    }, [state.data, state.isError, state.isLoading]);

     
    return (!props.hideCheckbetLayout &&
        <>
           
            {showLoader ?
                <Loader error={state.isError} positionRelative={props.isModal} />
                :
                <div id="cg-mybet-body" className="cg-mybet-section">
                {
                	!props.infoTicket &&                	
                	<div id="checkbet-logo-container">
                        <img src={logoURL} alt="" />
                    </div>
                }       
                    {data == null ?
                        <div id="my-bets-container">
                            <span>{getLabel('checkbet.wrong_ticket_id', 'Ticket non esistente')}</span>
                        </div>
                        :
                        <>
                            <div id="my-bets-container">
                                {data.type === 'singlebets' &&
                                    <SingleBetTicket key={data.id} ticket={data} infoTicket={props.infoTicket} obfuscateTicketId={props.obfuscateTicketId} />
                                }
                                {data.type === 'multibets' &&
                                    <MultipleBetsTicket key={data.id} ticket={data} infoTicket={props.infoTicket} obfuscateTicketId={props.obfuscateTicketId} />
                                }
                                {data.type === 'systembets' &&
                                    <SystemBetsTicket key={data.id} ticket={data} infoTicket={props.infoTicket} openCheckSystemBets={props.openCheckSystemBets} obfuscateTicketId={props.obfuscateTicketId} />
                                }
                            </div>
                            <div id="checkbet-legend-container">
                                <table className="table table-sm">
                                    <thead>
                                        <tr>
                                            <th scope="col" className="padding-left-10 bold">{getLabel('checkbet.color')}</th>
                                            <th scope="col" className="padding-left-10 bold">{getLabel('checkbet.meaning')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="padding-left-10 text-center"><span className="d-flex align-items-center margine-dx margine-sx bold esito-v"></span></td>
                                            <td className="padding-left-10">{getLabel('checkbet.winning_match')}</td>
                                        </tr>
                                        <tr>
                                            <td className="padding-left-10 text-center"><span className="d-flex align-items-center margine-dx margine-sx bold esito-p"></span></td>
                                            <td className="padding-left-10">{getLabel('checkbet.losing_match')}</td>
                                        </tr>
                                        <tr>
                                            <td className="padding-left-10 text-center"><span className="d-flex align-items-center margine-dx margine-sx bold esito-nd"></span></td>
                                            <td className="padding-left-10">{getLabel('checkbet.match_in_progress')}</td>
                                        </tr>
                                        <tr>
                                            <td className="padding-left-10 text-center"><span className="d-flex align-items-center margine-dx margine-sx bold esito-vd"></span></td>
                                            <td className="padding-left-10">{getLabel('checkbet.match_voided')}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* {
                            	!props.infoTicket &&
                            	<SocialShareButtons ticketUrl={ticketUrl} />
                            } */}
                            {
                            	props.infoTicket && !props.hideOperatorFunctions && 
        		        		<div className="checkbet-operator-functions">
                                   
                            		{
                            			conf.rs.pctk && window?.appConfig?.TERMINAL_AGENCY && 
                                		<div>
	                                        <div className="checkbet-button ml-auto mr-auto my-bets-printer" onClick={() => { window.printTerminalCopy(data.id)}}>
	                                            <i className="fas fa-print" />
	                                        </div>
	                                        <div className="checkbet-operator-functions-desc" >{getLabel('checkbet.print_copy')}</div>
                                        </div>
                            		}
                            		{
                            			data.reprintReceipt && window?.appConfig?.TERMINAL_AGENCY && 
                            			<div>
	                                        <div className="checkbet-button ml-auto mr-auto my-bets-printer" onClick={() => { window.reprintTerminalTicket(data.id); props.close();}}>
	                                            <i className="fas fa-print" />
	                                        </div>
	                                        <div className="checkbet-operator-functions-desc" >{getLabel('retail.operator_menu.form_button.reprint_receipt')}</div>
                                        </div>
                            		}

                                    <div id="retail-purchase-again">
                                        <div className="checkbet-button ml-auto mr-auto my-bets-cart" onClick={() => { props.purchaseTicket(data.id, data.psv) } }>
                                            <i className="fas fa-solid fa-coins"></i>
                                        </div>
                                        <div className="checkbet-operator-functions-desc" >{getLabel('checkbet.purchase_again')}</div>
                                    </div>
                                    <div>
                                        <div className="checkbet-button ml-auto mr-auto my-bets-cart" onClick={() => { props.reloadTicketInCart(data.id, data.psv) } }>
                                            <i className="fas fa-cart-plus" />
                                        </div>
                                        <div className="checkbet-operator-functions-desc" >{getLabel('checkbet.reload_in_betslip')}</div>
                                    </div>
                                </div>
                            }
                        </>
                    }
                </div>
            }
        </>
    )
}

export default CheckBetLayout1;